// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'

class PrayerRequest extends React.Component {
	render() {
		const { translate, contentId, sectionId, data } = this.props

		const fullData = {
			heading: data.heading || '',
			content: data.content || '',
			button: data.button || {
				url: '',
				text: ''
			}
		}

		return (
			<div className="section-prayer-request">
				<div className="-inner">
					<div className="-content">
						<div className="-heading">
							<Editable
								element="h2"
								id={ contentId }
								sectionId={ sectionId }
								sectionType={ data.type }
								sectionDataId="heading"
								content={ fullData.heading }
							/>
						</div>

						<div className="-text">
							<Editable
								element="p"
								id={ contentId }
								sectionId={ sectionId }
								sectionType={ data.type }
								sectionDataId="content"
								content={ fullData.content }
							/>
						</div>

						<div className="-action">
							<Editable
								id={ contentId }
								sectionId={ sectionId }
								sectionType={ data.type }
								sectionDataId="button"
								linkUrl={ fullData.button.url }
								linkText={ fullData.button.text }
							/>

							<Link to={ fullData.button.url } className="button">{ fullData.button.text }</Link>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default localize( PrayerRequest )
